// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__f0mc3","savePackageButton":"ClientWallet_savePackageButton__3Bsmu"};